import { RenderElementProps } from 'slate-react';

export const ELEMENT_QUESTION_LIST = 'ol';
export const ELEMENT_QUESTION_LIST_ITEM = 'li';

export interface QuestionListPluginOptions {
  isReadOnly?: boolean;
}

export interface BaseQuestionListPluginProps
  extends RenderElementProps,
    QuestionListPluginOptions {}
